declare function require(moduleName: string): any;
const { version } = require('../../package.json');

export const config = () => {
  return {
    version,
    debug: false,
    langs: ['en', 'es'],
    defaults: {
      lang: 'es',
      grantType: 'password',
      clientId: 'defaultClientId'
    },
    enabledCountries: ['us', 'co'],
    services: {
      auth: 'oauth',
      accounts: 'accounts',
      users: 'users',
      locations: 'locations',
      roles: 'roles',
      projects: 'projects',
      dailyLogs: 'daily_logs',
      contract_walkthroughs: 'contract_walkthroughs',
      dailyLogDefinitions: 'daily_log_definitions',
      contracts: 'contracts',
      companies: 'companies',
      csiDivision: 'csi_divisions',
      contractDefinitions: 'contract_definitions',
      contractTypes: 'contract_types',
      globalTrades: 'global_trades',
      widgets: 'widgets',
      contractsDefinitions: 'contract_definitions',
      questionnaires: 'questionnaires',
      lookup: 'entity_lookup',
      billing: 'billing',
      readers: 'readers'
    },
    postmanMockKey: 'b0f5223536694b41945ec1aa94451696',
    mockServerUrl: "https://ca41af24-5583-4392-8007-947ce333ef84.mock.pstmn.io"
  };
};
